module.exports = __webpack_public_path__ + "static/media/ybor-slide-03.7300f3fd.png";